import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import { pbdqFont } from '../theme/pbdqTokens';
import { useAgentChat } from './PbdqAgentChatContext';
import { PBDQ_SOLUTIONS_CONFIG } from '../constants/pbdqSolutions.constants';
import SolutionsFirst from '../../../assets/images/PoweredByDQ/SolutionsFirst.png';
import SolutionsSecond from '../../../assets/images/PoweredByDQ/SolutionsSecond.png';
import SolutionsThird from '../../../assets/images/PoweredByDQ/SolutionsThird.png';
import SolutionsFourth from '../../../assets/images/PoweredByDQ/SolutionsFourth.png';
import SolutionsFifth from '../../../assets/images/PoweredByDQ/SolutionsFifth.png';

const SOLUTION_IMAGES = [
    SolutionsFirst,
    SolutionsSecond,
    SolutionsThird,
    SolutionsFourth,
    SolutionsFifth,
];

const TABS_CONFIG = PBDQ_SOLUTIONS_CONFIG;

const useStyles = makeStyles(() => ({
    solutionsSection: {
        background: '#FFFFFF',
    },
    solutionsInner: {
        maxWidth: 1320,
        margin: '0 auto',
        padding: 'clamp(48px, 6vw, 80px) clamp(20px, 4vw, 56px) 0',
        boxSizing: 'border-box',
    },
    sectionHeader: {
        display: 'grid',
        gap: 12,
        marginBottom: 36,
        textAlign: 'left',
    },
    listTitle: {
        fontSize: 'clamp(26px, 3vw, 42px)',
        lineHeight: 1.1,
        letterSpacing: '-0.025em',
        fontWeight: 800,
        margin: 0,
        color: '#1B2430',
        fontFamily: pbdqFont,
    },
    listLead: {
        fontSize: 16,
        lineHeight: 1.55,
        margin: 0,
        color: '#5B6470',
        fontFamily: pbdqFont,
    },
    tabRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
        gap: 12,
        marginBottom: 32,
        '@media (max-width: 900px)': {
            gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 200px), 1fr))',
        },
    },
    tabBtn: {
        display: 'grid',
        gap: 12,
        alignContent: 'start',
        textAlign: 'left',
        padding: '18px 18px 20px',
        borderRadius: 18,
        color: '#1B2430',
        cursor: 'pointer',
        fontFamily: pbdqFont,
        transition: 'background 240ms cubic-bezier(.32,.72,0,1), border-color 240ms cubic-bezier(.32,.72,0,1), transform 240ms cubic-bezier(.32,.72,0,1)',
        border: '1px solid #E6E9EE',
        borderLeft: '4px solid #68C3EE',
        background: '#FFFFFF',
        outline: 'none',
        '&:hover': {
            transform: 'translateY(-2px)',
        },
    },
    tabHeaderRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 8,
    },
    tabIconBox: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 44,
        height: 44,
        borderRadius: 12,
    },
    tabNum: {
        fontSize: 12,
        fontWeight: 700,
        color: '#6B7280',
        fontVariantNumeric: 'tabular-nums',
    },
    tabName: {
        fontSize: 16,
        fontWeight: 800,
        lineHeight: 1.25,
        letterSpacing: '-0.01em',
        color: '#1B2430',
    },
    tabEyebrow: {
        fontSize: 13,
        color: '#6B7280',
        lineHeight: 1.4,
    },

    // Selected panel card
    panelCard: {
        border: '1px solid #E6E9EE',
        borderRadius: 24,
        background: '#FFFFFF',
        overflow: 'hidden',
    },
    panelHeader: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '20px 24px',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 'clamp(22px, 2.8vw, 36px) clamp(22px, 3vw, 44px)',
        borderBottom: '3px solid #68C3EE',
        boxSizing: 'border-box',
    },
    panelHeaderLeft: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 20,
        minWidth: 0,
    },
    panelBigIcon: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 84,
        height: 84,
        borderRadius: 18,
        background: '#FFFFFF',
        flex: 'none',
        boxShadow: '0 4px 12px rgba(0,0,0,0.04)',
    },
    panelMeta: {
        display: 'grid',
        gap: 8,
        minWidth: 0,
    },
    panelEyebrow: {
        fontSize: 12,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        fontWeight: 700,
        color: '#2A4057',
        fontFamily: pbdqFont,
    },
    panelTitle: {
        fontSize: 'clamp(24px, 2.6vw, 34px)',
        lineHeight: 1.1,
        letterSpacing: '-0.02em',
        fontWeight: 800,
        margin: 0,
        color: '#1B2430',
        fontFamily: pbdqFont,
    },
    panelSubtitle: {
        fontSize: 17,
        lineHeight: 1.4,
        fontWeight: 700,
        margin: 0,
        color: '#A63C0C',
        fontFamily: pbdqFont,
    },
    panelCounter: {
        fontSize: 14,
        fontWeight: 700,
        color: '#5B6470',
        fontVariantNumeric: 'tabular-nums',
        whiteSpace: 'nowrap',
        fontFamily: pbdqFont,
    },

    panelBody: {
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1.15fr) minmax(0, 1fr)',
        gap: 'clamp(28px, 4vw, 56px)',
        alignItems: 'center',
        padding: 'clamp(24px, 3.5vw, 44px)',
        boxSizing: 'border-box',
        '@media (max-width: 900px)': {
            gridTemplateColumns: '1fr',
        },
    },
    panelLeft: {
        display: 'grid',
        gap: 22,
        alignContent: 'start',
    },
    panelDesc: {
        fontSize: 16,
        lineHeight: 1.65,
        margin: 0,
        color: '#5B6470',
        fontFamily: pbdqFont,
    },
    panelPricePill: {
        display: 'inline-flex',
        width: 'max-content',
        alignItems: 'center',
        padding: '7px 12px',
        borderRadius: 999,
        background: '#F4F6F9',
        fontSize: 13,
        fontWeight: 700,
        whiteSpace: 'nowrap',
        color: '#1B2430',
        fontFamily: pbdqFont,
    },
    panelActions: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 10,
        marginTop: 6,
    },
    btnExplore: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        height: 48,
        padding: '0 22px',
        borderRadius: 999,
        background: '#ED6628',
        color: '#FFFFFF',
        textDecoration: 'none',
        fontSize: 14.5,
        fontWeight: 700,
        whiteSpace: 'nowrap',
        fontFamily: pbdqFont,
        transition: 'background 200ms cubic-bezier(.32,.72,0,1)',
        '&:hover': {
            background: '#D5581D',
            color: '#FFFFFF',
            textDecoration: 'none',
        },
    },
    btnBuild: {
        display: 'inline-flex',
        alignItems: 'center',
        height: 48,
        padding: '0 22px',
        borderRadius: 999,
        background: '#FFFFFF',
        color: '#1B2430',
        border: '1px solid #D5D9E0',
        textDecoration: 'none',
        fontSize: 14.5,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        fontFamily: pbdqFont,
        cursor: 'pointer',
        transition: 'border-color 200ms cubic-bezier(.32,.72,0,1), background 200ms cubic-bezier(.32,.72,0,1)',
        '&:hover': {
            borderColor: '#1B2430',
            background: '#F8F9FA',
            color: '#1B2430',
        },
    },

    bulletsList: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        display: 'grid',
        gap: 14,
        alignContent: 'start',
    },
    bulletItem: {
        display: 'grid',
        gridTemplateColumns: '18px 1fr',
        gap: 12,
        fontSize: 15.5,
        lineHeight: 1.55,
        color: '#1B2430',
        fontFamily: pbdqFont,
    },
    checkSvg: {
        marginTop: 2,
    },

    panelRight: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 0,
    },
    panelImage: {
        width: '100%',
        maxWidth: 560,
        height: 'auto',
        display: 'block',
    },
}));

const PbdqSolutionsExplorer = ({ solutions }) => {
    const classes = useStyles();
    const openAgentChat = useAgentChat();
    const { hash } = useLocation();
    const [active, setActive] = useState(0);

    // Sync active tab with hash, and listen for solution-selected events
    useEffect(() => {
        const updateFromHash = () => {
            const currentHash = window.location.hash;
            if (currentHash) {
                const cleanHash = currentHash.replace(/^#/, '');
                const foundIndex = solutions.findIndex((s, idx) => {
                    const id = s.id || `solution-${s.index || idx + 1}`;
                    return cleanHash === id || cleanHash === `solutions-${idx + 1}` || cleanHash === s.index;
                });
                if (foundIndex !== -1) {
                    setActive(foundIndex);
                }
            }
        };

        updateFromHash();

        const handleSolutionSelected = (e) => {
            if (typeof e.detail?.index === 'number') {
                setActive(e.detail.index);
            }
        };

        window.addEventListener('pbdq-solution-selected', handleSolutionSelected);
        window.addEventListener('hashchange', updateFromHash);
        return () => {
            window.removeEventListener('pbdq-solution-selected', handleSolutionSelected);
            window.removeEventListener('hashchange', updateFromHash);
        };
    }, [hash, solutions]);

    const solution = solutions[active] || solutions[0];
    const cfg = TABS_CONFIG[active % TABS_CONFIG.length];

    return (
        <section id="solutions" aria-label="Solutions" className={classes.solutionsSection}>
            <div className={classes.solutionsInner}>
                <div className={classes.sectionHeader}>
                    <h2 className={classes.listTitle}>
                        Choose the <span style={{ color: '#ED6628' }}>solution</span> your organization needs
                    </h2>
                    <p className={classes.listLead}>
                        Pick a solution to see what it measures, what it delivers and how to get started.
                    </p>
                </div>

                <div role="tablist" aria-label="Solutions" className={classes.tabRow}>
                    {solutions.map((s, i) => {
                        const c = TABS_CONFIG[i % TABS_CONFIG.length];
                        const isSelected = i === active;
                        return (
                            <button
                                key={s.index}
                                type="button"
                                role="tab"
                                aria-selected={isSelected}
                                onClick={() => setActive(i)}
                                className={classes.tabBtn}
                                style={{
                                    borderTop: `1px solid ${isSelected ? '#D9E0E8' : '#E6E9EE'}`,
                                    borderRight: `1px solid ${isSelected ? '#D9E0E8' : '#E6E9EE'}`,
                                    borderBottom: `1px solid ${isSelected ? '#D9E0E8' : '#E6E9EE'}`,
                                    borderLeft: `5px solid ${c.bar}`,
                                    background: isSelected ? c.tint : '#FFFFFF',
                                }}
                            >
                                <span className={classes.tabHeaderRow}>
                                    <span
                                        className={classes.tabIconBox}
                                        style={{ background: c.tint, color: c.ink }}
                                    >
                                        <svg
                                            width="22"
                                            height="22"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            aria-hidden="true"
                                        >
                                            <path d={c.icon} />
                                        </svg>
                                    </span>
                                    <span className={classes.tabNum}>{c.num}</span>
                                </span>
                                <span className={classes.tabName}>{s.shortTitle || s.title}</span>
                                <span className={classes.tabEyebrow}>{s.category}</span>
                            </button>
                        );
                    })}
                </div>

                {/* Selected Solution Detail Tabpanel */}
                <div role="tabpanel" id="solution-detail" aria-label="Selected solution" className={classes.panelCard}>
                    <div
                        className={classes.panelHeader}
                        style={{
                            background: cfg.tint,
                            borderBottom: `3px solid ${cfg.bar}`,
                        }}
                    >
                        <div className={classes.panelHeaderLeft}>
                            <span className={classes.panelBigIcon} style={{ color: cfg.ink }}>
                                <svg
                                    width="40"
                                    height="40"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="1.6"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    aria-hidden="true"
                                >
                                    <path d={cfg.icon} />
                                </svg>
                            </span>
                            <div className={classes.panelMeta}>
                                <div>
                                    <span className={classes.panelEyebrow}>{solution.category}</span>
                                </div>
                                <h3 className={classes.panelTitle}>{solution.title}</h3>
                                <p className={classes.panelSubtitle}>{solution.subtitle}</p>
                            </div>
                        </div>
                        <span className={classes.panelCounter}>{cfg.num} / 05</span>
                    </div>

                    <div className={classes.panelBody}>
                        <div className={classes.panelLeft}>
                            <p className={classes.panelDesc}>{solution.description}</p>
                            <ul className={classes.bulletsList}>
                                {solution.features.map((bullet) => (
                                    <li key={bullet} className={classes.bulletItem}>
                                        <svg
                                            width="18"
                                            height="18"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="#ED6628"
                                            strokeWidth="2.2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className={classes.checkSvg}
                                            aria-hidden="true"
                                        >
                                            <path d="m5 12 5 5L20 7" />
                                        </svg>
                                        <span>{bullet}</span>
                                    </li>
                                ))}
                            </ul>
                            <div className={classes.panelActions}>
                                <Link to={solution.to} className={classes.btnExplore}>
                                    Explore the solution →
                                </Link>
                                <button
                                    type="button"
                                    onClick={openAgentChat}
                                    className={classes.btnBuild}
                                >
                                    Build your solution
                                </button>
                            </div>
                        </div>
                        <div className={classes.panelRight}>
                            <img
                                src={SOLUTION_IMAGES[active % SOLUTION_IMAGES.length]}
                                alt={solution.title}
                                className={classes.panelImage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PbdqSolutionsExplorer;
